// ...existing code...
export const dictionary = {
  loginTitle: {
    pl: "Logowanie",
    en: "Log in",
  },
  registerTitle: {
    pl: "Rejestracja",
    en: "Sign up",
  },
  forgetTitle: {
    pl: "Przypomnienie hasła",
    en: "Password reminder",
  },
  emailSend: {
    pl: "Wiadomość wysłana",
    en: "Message sent",
  },
  listsSettings: {
    pl: "Ustawienia list",
    en: "List settings",
  },

  resetTitle: {
    pl: "Ustaw nowe hasło",
    en: "Set new password",
  },
  afterResetTitle: {
    pl: "Gotowe",
    en: "Done",
  },
  sendSubtitle: {
    pl: "Jeśli istnieje konto przypisane do tego adresu email to wysłaliśmy tam dalsze instrukcje",
    en: "If there is an account registered with this email address you will receive further instructions there",
  },

  loginSubtitle: {
    pl: "Witaj z powrotem, zaloguj się na swoje konto",
    en: "Welcome back, log in to your account",
  },
  afterResetSubtitle: {
    pl: "Hasło zostało pomyślnie zmienione, możesz zalogować się do aplikacji",
    en: "The password has been successfully changed, you can log in to the application",
  },
  forgotSubtitle: {
    pl: "Podaj swój email i podążaj za instrukcjami",
    en: "Enter your email and follow the instructions",
  },
  registerSubtitle: {
    pl: "Utwórz konto aby korzystać z aplikacji",
    en: "Create an account to use the application",
  },
  passwordSubtitle: {
    pl: "Utwórz hasło dla swojego konta.",
    en: "Create a password for your account.",
  },
  invoiceData: {
    pl: "Dane do faktury.",
    en: "Invoice details.",
  },
  planSubtitle: {
    pl: "Wybierz plan.",
    en: "Select a plan.",
  },
  inputLabelEmail: {
    pl: "Email",
    en: "E-mail",
  },
  inputLabelOrganization: {
    pl: "Nazwa organizacji",
    en: "Organization name",
  },
  inputLabelPassword: {
    pl: "Hasło",
    en: "Password",
  },
  inputLabelRePassword: {
    pl: "Powtórz hasło",
    en: "Repeat password",
  },
  inputVerificationCode: {
    pl: "Kod weryfikujący",
    en: "Verification code",
  },

  errorWrongLoginOrPassword: {
    pl: "Błędny login lub hasło",
    en: "Incorrect login or password",
  },
  actionLogin: {
    pl: "Zaloguj",
    en: "Log in",
  },
  backToLogin: {
    pl: "Powrót do strony logowania",
    en: "Back to login",
  },
  actionReset: {
    pl: "Wyślij",
    en: "Send",
  },
  setPassword: {
    pl: "Ustaw hasło",
    en: "Set password",
  },

  actionRemember: {
    pl: "Przypomniałeś sobie?",
    en: "Did you remember?",
  },
  backToHomePage: {
    pl: "Strona logowania",
    en: "Login page",
  },
  dontRemeberPassword: {
    pl: "Nie pamiętasz hasła?",
    en: "Forgot password?",
  },
  dontHaveAccount: {
    pl: "Nie masz konta?",
    en: "Don't have an account?",
  },
  doYouHaveAccount: {
    pl: "Masz już konto?",
    en: "Already have an account?",
  },
  registerAccount: {
    pl: "Zarejestruj się",
    en: "Register",
  },
  loginAccount: {
    pl: "Zaloguj się",
    en: "Sign in",
  },
  verificationCodeInstruction: {
    pl: "Na podany adres wysłaliśmy wiadomość z kodem weryfikującym, wpisz kod z wiadomości w pole poniżej",
    en: "We have sent a message with a verification code to the provided address, enter the code from the message in the field below",
  },
  sendCodeAgain: {
    pl: "Wyślij nowy kod",
    en: "Send new code",
  },

  setting: {
    pl: "Ustawienia",
    en: "Settings",
  },
  logout: {
    pl: "Wyloguj",
    en: "Logout",
  },
  projectName: {
    pl: "Nazwa projektu",
    en: "Project name",
  },
  project: {
    pl: "Projekt",
    en: "Project",
  },
  createdTime: {
    pl: "Data utworzenia",
    en: "Created date",
  },
  updatedTime: {
    pl: "Data modyfikacji",
    en: "Update date",
  },
  changeName: {
    pl: "Zmień nazwę",
    en: "Change name",
  },
  deleteProject: {
    pl: "Usuń projekt",
    en: "Delete project",
  },
  addProject: {
    pl: "Dodaj projekt",
    en: "Add project",
  },
  newProject: {
    pl: "Nowy projekt",
    en: "New project",
  },
  editProject: {
    pl: "Edytuj projekt",
    en: "Edit project",
  },
  createProject: {
    pl: "Utwórz projekt",
    en: "Create project",
  },
  newSection: {
    pl: "Nowa sekcja",
    en: "New section",
  },
  addSection: {
    pl: "Dodaj sekcje",
    en: "Add section",
  },
  sectionName: {
    pl: "Nazwa sekcji",
    en: "Section name",
  },
  section: {
    pl: "Sekcja",
    en: "Section",
  },
  maxFileSize: {
    pl: "Maksymalny rozmiar pliku: 25MB",
    en: "Maximum file size: 25MB",
  },

  createSection: {
    pl: "Utwórz sekcje",
    en: "Create section",
  },
  editSection: {
    pl: "Edytuj sekcje",
    en: "Edit section",
  },
  deleteSection: {
    pl: "Usuń sekcje",
    en: "Delete section",
  },
  newRevision: {
    pl: "Wgraj nową rewizję",
    en: "Add new revision",
  },
  revision: {
    pl: "Rewizja",
    en: "Revision",
  },
  kks: {
    pl: "KKS",
    en: "KKS",
  },
  spool: {
    pl: "Spool",
    en: "Spool",
  },
  spoolID: {
    pl: "Spool",
    en: "Spool",
  },
  status: {
    pl: "Status",
    en: "Status",
  },
  fileName: {
    pl: "Nazwa pliku",
    en: "File name",
  },
  pdfFile: {
    pl: "Plik .pdf z projektem sekcji",
    en: ".pdf file with section project",
  },
  file: {
    pl: "Plik .pdf z projektem sekcji",
    en: ".pdf file with section project",
  },
  cancel: {
    pl: "Anuluj",
    en: "Cancel",
  },
  next: {
    pl: "Dalej",
    en: "Next",
  },
  back: {
    pl: "Wróć",
    en: "Back",
  },
  save: {
    pl: "Zapisz",
    en: "Save",
  },
  confirm: {
    pl: "Zatwierdź",
    en: "Confirm",
  },
  edit: {
    pl: "Edytuj",
    en: "Edit",
  },
  close: {
    pl: "Zamknij",
    en: "Close",
  },
  delete: {
    pl: "Usuń",
    en: "Delete",
  },
  duplicate: {
    pl: "Duplikuj",
    en: "Duplicate",
  },
  lock: {
    pl: "Zablokuj",
    en: "Lock",
  },
  add: {
    pl: "Dodaj",
    en: "Add",
  },
  unlock: {
    pl: "Odblokuj",
    en: "Unlock",
  },
  order: {
    pl: "Zamawiam",
    en: "Upgrade",
  },
  verify: {
    pl: "Weryfikuj",
    en: "Verify",
  },
  createAnAccount: {
    pl: "Załóż konto",
    en: "Create an account",
  },
  closeAccount: {
    pl: "Usuń konto",
    en: "Delete account",
  },

  setReference: {
    pl: "Ustaw referencje",
    en: "Set reference",
  },
  export: {
    pl: "Export",
    en: "Export",
  },
  selectFilters: {
    pl: "Wybierz filtry",
    en: "Select filters",
  },
  clearFilters: {
    pl: "Wyczyść filtry",
    en: "Reset filters",
  },
  clearSort: {
    pl: "Wyczyść sortowanie",
    en: "Reset sort",
  },

  editModalTitle: {
    pl: "Edytujesz",
    en: "Edit",
  },
  map: {
    pl: "Mapa",
    en: "Map",
  },
  list: {
    pl: "Lista",
    en: "List",
  },
  pointsMap: {
    pl: "Mapa punktów",
    en: "Points map",
  },
  pointsList: {
    pl: "Lista punktów",
    en: "Points list",
  },
  page: {
    pl: "Strona",
    en: "Page",
  },
  selectExistingJoint: {
    pl: "Wybierz istniejącą spoiną",
    en: "Select an existing weld",
  },
  reference: {
    pl: "Referencja",
    en: "Reference",
  },
  referencePanelTitle: {
    pl: "Wybierz referencje",
    en: "Select reference",
  },
  referencePanelEmpty: {
    pl: "Musisz dodać punkt aby móc wskazać go jako referencje",
    en: "You need to add a point to be able to select it as a reference",
  },
  noSelectedItem: {
    pl: "Nie jest wybrany żaden element",
    en: "No item is selected",
  },
  joint_name: {
    pl: "Numer spoiny",
    en: "Weld joint number",
  },
  joint_type: {
    pl: "Typ spoiny",
    en: "Weld joint type",
  },
  element_type: {
    pl: "Typ elementu",
    en: "Element type",
  },
  element_type_1: {
    pl: "Typ elementu 1",
    en: "Element type 1",
  },
  element_type_2: {
    pl: "Typ elementu 2",
    en: "Element type 2",
  },
  diameter_1: {
    pl: "Średnica 1",
    en: "Diameter 1",
  },
  diameter_2: {
    pl: "Średnica 2",
    en: "Diameter 2",
  },
  thickness_1: {
    pl: "Grubość 1",
    en: "Thickness 1",
  },
  thickness_2: {
    pl: "Grubość 2",
    en: "Thickness 2",
  },
  material_1: {
    pl: "Materiał 1",
    en: "Material 1",
  },
  material_2: {
    pl: "Materiał 2",
    en: "Material 2",
  },
  loading: {
    pl: "Trwa ładowanie ...",
    en: "Loading...",
  },
  confirmDelete: {
    pl: "Potwierdź usunięcie",
    en: "Confirm delete",
  },
  doYouWantDeletePoint: {
    pl: "Czy chcesz usunąć ten punkt?",
    en: "Do you want to delete this point",
  },
  doYouWantDeletePointWithReferences: {
    pl: "Ta spoina jest takze uzyta na innych rysunkach. Usuwając ją, usuniesz wszystkie pozostałe jej wystąpienia. Czy chcesz usunąć ten punkt?",
    en: "This weld is also used in other drawings. Deleting it will remove it from all drawings. Do you want to delete this point?",
  },
  doYouWantDeleteElement: {
    pl: "Czy chcesz usunąć ten element?",
    en: "Do you want to delete this element",
  },
  doYouWantDeleteSection: {
    pl: "Czy chcesz usunąć tę sekcję wraz z wszystkimi punktami?",
    en: "Do you want to delete this section with all points?",
  },
  doYouWantDeleteProject: {
    pl: "Czy chcesz usunąć ten projekt wraz z wszystkimi sekcjami oraz punktami?",
    en: "Do you want to delete this project with all sections and points?",
  },
  doYouWantDeleteContract: {
    pl: "Czy chcesz usunąć ten kontract wraz z wszystkimi projektami?",
    en: "Do you want to delete this contract and its projects?",
  },
  doYouWantDeleteAccount: {
    pl: "Chcesz usunąć swoje konto. Nieodwracalnie utracisz dostęp do aplikacji. Czy jesteś pewien że chcesz to zrobić?",
    en: "You want to delete your account. You will irreversibly lose access to the application. Are you sure you want to do this?",
  },
  doYouWantDeleteUser: {
    pl: "Chcesz usunąć konto tego użytkownika. Nieodwracalnie utraci on dostęp do aplikacji. Czy jesteś pewien że chcesz to zrobić?",
    en: "You want to delete this user's account. They will irreversibly lose access to the application. Are you sure you want to do this?",
  },
  doYouWantDeleteSpool: {
    pl: "Czy chcesz usunąć tego spoola. Usunięte zostaną wszystkie instancje tego spoola, a także usunięty zostanie ze wszystkich spoin do których był przypisany?",
    en: "Do you want to delete this spool? All instances of this spool will be deleted and it will be removed from all spools to which it was assigned.",
  },
  doYouWantDeleteSpoolInstance: {
    pl: "Czy chcesz usunąć tę instancję spoola?",
    en: "Do you want to delete this spool instance?",
  },
  confirmAccountDelete: {
    pl: "Aby potwierdzić usunięcie konta wpisz swój adres email w pole poniżej",
    en: "To confirm account deletion, enter your e-mail address in the field below",
  },
  confirmUserAccountDelete: {
    pl: "Aby potwierdzić usunięcie konta wpisz adres email konta które chcesz usunąć w pole poniżej",
    en: "To confirm account deletion, enter the email address of the account you want to delete in the field below",
  },

  orgMailNeedChange: {
    pl: "Usuwany adres e-mail używany jest jako główny adres twojej organizacji, wybierz z listy inny adres email który będzie pełnił role głównego adresu",
    en: "The email address you are deleting is used as your organization's primary email address. Select a different email address from the list to use as your primary email address.",
  },
  enterEmailAddress: {
    pl: "Wpisz adres email",
    en: "Enter your email address",
  },
  newItem: {
    pl: "Nowy element",
    en: "New item",
  },
  details: {
    pl: "Szczegóły",
    en: "Details",
  },
  edition: {
    pl: "Edycja:",
    en: "Edition:",
  },
  generateXlsxFile: {
    pl: "Generuj plik .xlsx",
    en: "Generate .xlsx file",
  },
  generatePdfFile: {
    pl: "Generuj mapę .pdf",
    en: "Generate .pdf map",
  },
  invoicesList: {
    pl: "Lista faktur",
    en: "Invoices list",
  },
  userLimitModal: {
    pl: "Limit użytkowników",
    en: "User limit",
  },
  userLimiContent: {
    pl: "Osiągnąłeś limit użytkowników, nie można dodać nowego użytkownika.",
    en: "You have reached your user limit, you cannot add a new user.",
  },
  subscribtion: {
    pl: "Subskrypcja",
    en: "Subscription",
  },
  passwordCheckLength: {
    pl: "Minimum 6 znaków",
    en: "Minimum 6 characters",
  },
  passwordCheckLowercase: {
    pl: "Przynajmniej jedna mała litera",
    en: "At least one lowercase letter",
  },
  passwordCheckUppercase: {
    pl: "Przynajmniej jedna wielka litera",
    en: "At least one capital letter",
  },
  passwordCheckDigit: {
    pl: "Przynajmniej jedna cyfra",
    en: "At least one number",
  },
  passwordCheckSpecial: {
    pl: "Przynajmniej jeden znak specjalny",
    en: "At least one special character",
  },
  passwordMatchCheckSpecial: {
    pl: "Hasła muszą być takie same",
    en: "Passwords must be the same",
  },

  paymentTitleFail: {
    pl: "Błąd płatności",
    en: "Payment error",
  },
  paymentTitleSuccess: {
    pl: "Płatność kompletna",
    en: "Payment complete",
  },
  paymentTitleMissed: {
    pl: "Opłać usługi",
    en: "Pay for the services",
  },
  paymentTitleNotComplete: {
    pl: "Nieopłacona subskrypcja",
    en: "Unpaid subscription",
  },
  paymentContentSuccess: {
    pl: "Płatność zakończyła się sukcesem. Twoja subskrypcja jest aktywna. Zostaniesz przeniesiony na stronę główną za: ",
    en: "The payment was successful. Your subscription is active. You will be redirected to the home page: ",
  },
  paymentContentFail: {
    pl: "Nie mogliśmy pobrać płatności za następny okres subskrypcji. Aby dalej korzystać z aplikacji aktualizuj ustawienia metody płatności.",
    en: "We were unable to collect payment for your next subscription period. To continue using the application, update your payment method settings.",
  },
  paymentContentMissed: {
    pl: "Aby dalej korzystać z systemu opłać swoją subskrypcję.",
    en: "To continue using the system, pay your subscription.",
  },
  finishSubskrypcjeAdmin: {
    pl: "Aby korzystać z aplikacji, sfinalizuj subskrypcje",
    en: "To use the app, please finalize your subscriptions.",
  },
  finishSubskrypcjeUser: {
    pl: "Twoja organizacja nie jest aktywna, skontaktuj się z administratorem swojej organizacji, aby dokończył proces rejestracji.",
    en: "Your organization is not active, please contact your organization administrator to complete the registration process.",
  },
  errorPaymentUser: {
    pl: "Twoja organizacja nie jest aktywna, skontaktuj się z administratorem swojej organizacji, aby opłacił subskrypcje.",
    en: "Your organization is not active, please contact your organization's administrator to pay for your subscriptions.",
  },
  finishSubsrybcionAction: {
    pl: "Dokończ płatność",
    en: "Complete your payment",
  },
  seconds: {
    pl: "sekund",
    en: "seconds",
  },

  errorPaymentAction: {
    pl: "Zaktualizuj dane płatności",
    en: "Update your payment details",
  },
  email: {
    pl: "Email",
    en: "E-mail",
  },
  role: {
    pl: "Rola użytkownika",
    en: "User role",
  },
  accountType: {
    pl: "typ konta",
    en: "account type",
  },
  upgrade: {
    pl: "ulepsz",
    en: "upgrade",
  },
  tin: {
    pl: "NIP",
    en: "TAX ID",
  },
  taxID:{
    pl: "Numer podatkowy",
    en: "Tax ID",
  },
  vatEU:{
    pl: "VAT UE",
    en: "VAT EU",
  },
  billingAddress: {
    pl: "Adres rozliczeniowy",
    en: "Billing address",
  },
  billingSettings: {
    pl: "Ustawienia płatności",
    en: "Billing settings",
  },
  invoices: {
    pl: "Faktury",
    en: "Invoices",
  },
  deleteAccount: {
    pl: "Usuń konto",
    en: "Delete account",
  },
  unsubscribe: {
    pl: "Anuluj subskrypcję",
    en: "Cancel subscription",
  },
  reactivateSubscribe: {
    pl: "Przywróć subskrypcję",
    en: "Reactivate subscription",
  },
  appVersion: {
    pl: "wersja aplikacji",
    en: "app version",
  },
  account: {
    pl: "Konto",
    en: "Account",
  },
  appSettings: {
    pl: "Ustawienia aplikacji",
    en: "App settings",
  },
  lang: {
    pl: "Język",
    en: "Language",
  },
  payment: {
    pl: "Płatności",
    en: "Payment",
  },
  paymentDetails: {
    pl: "Szczegóły płatności",
    en: "Payment details",
  },
  organizationInfos: {
    pl: "Informacje o organizacji",
    en: "Overview",
  },
  invoicesAndSettlements: {
    pl: "Faktury i rozliczenia",
    en: "Invoices and settlements",
  },
  administration: {
    pl: "Administracja",
    en: "Administration",
  },
  monthly: {
    pl: "miesięcznie",
    en: "monthly",
  },
  planComparison: {
    pl: "Porównanie planów",
    en: "Comparison of plans",
  },
  emptyStateProjectTitle: {
    pl: "Nie masz dodanego żadnego projektu",
    en: "You don't have any projects added",
  },
  noContractsUserMode: {
    pl: "W twojej organizacji nie ma dodanych żadnych kontraktów, skontaktuj się z administratorem organizacji",
    en: "There are no contracts added in your organization, please contact your organization's administrator",
  },
  emptyStateSectionTitle: {
    pl: "Nie masz dodanej żadnej sekcji",
    en: "You don't have any sections added",
  },
  emptyStateProjectListTitle: {
    pl: "Brak spoin w projekcie",
    en: "No welds in this project",
  },
  emptyStateContractsListTitle: {
    pl: "Nie masz dodanych żadnych kontraktów",
    en: "You have not added any contracts",
  },
  emptyStateStartPage: {
    pl: 'Aby rozpocząć dodaj najpierw kontrakt, potem możesz nimi zarządzać w zakładce "Organizacja"',
    en: 'To get started, first add a contract, then you can manage them in the "Organization" tab',
  },
  invoiceNumber: {
    pl: "Numer faktury",
    en: "Invoice number",
  },
  date: {
    pl: "Data",
    en: "Date",
  },
  price: {
    pl: "Kwota",
    en: "Price",
  },
  userExist: {
    pl: "Użytkownik już istnieje",
    en: "User exist",
  },
  wrongEmail: {
    pl: "Błędny format adresu email",
    en: "Wrong e-mail address format",
  },
  wrongCode: {
    pl: "Błędny kod",
    en: "Wrong code",
  },
  incorectEmail: {
    pl: "Adres email nie pasuje do zaproszenia",
    en: "The email address does not match the invitation",
  },
  serverError: {
    pl: "Wystąpił błąd w połączeniu z serwerem, spróbuj ponownie lub skontaktuj się z nami",
    en: "There was an error connecting to the server, please try again or contact us",
  },
  serverErrorTitle: {
    pl: "Błąd serwera",
    en: "Server error",
  },
  confirmSubscribtionPlan: {
    pl: "Wybrany plan",
    en: "Selected plan",
  },
  confirmSubscribtionPrice: {
    pl: "Kwota",
    en: "Price",
  },
  confirmSubscribtionFree: {
    pl: "Po kliknięciu 'Zamawiam' zostaniesz przeniesiony do systemu płatności, gdzie sfinalizujesz płatność.",
    en: "After clicking 'Order', you will be transferred to the system payments where you will finalize the payment.",
  },
  confirmSubscribtionPaid: {
    pl: "Twoja subskrypcja zostanie zaktualizowana",
    en: "Your subscription will be updated",
  },
  scale: {
    pl: "Skala",
    en: "Scale",
  },
  organization: {
    pl: "Organizacja",
    en: "Organization",
  },
  organizationPanel: {
    pl: "Panel Organizacji",
    en: "Organization Panel",
  },
  users: {
    pl: "Użytkownicy",
    en: "Users",
  },
  contracts: {
    pl: "Kontrakty",
    en: "Contracts",
  },
  addContract: {
    pl: "Dodaj kontrakt",
    en: "Add contract",
  },
  addUser: {
    pl: "Dodaj użytkownika",
    en: "Add user",
  },
  createNewContract: {
    pl: "Utwórz nowy kontrakt",
    en: "Create new contract",
  },
  editContractName: {
    pl: "Edycja kontraktu",
    en: "Edit contract name",
  },
  contractName: {
    pl: "Nazwa kontraktu",
    en: "Contract name",
  },
  contractNameTable: {
    pl: "Nazwa kontraktu",
    en: "Contract name",
  },
  contract: {
    pl: "Kontrakt",
    en: "Contract",
  },
  author: {
    pl: "Autor",
    en: "Author",
  },
  organizationDetails: {
    pl: "Organizacja",
    en: "Organization",
  },
  mapElementDot: {
    pl: "Punkt",
    en: "Point",
  },
  mapElementTriage: {
    pl: "Trójkąt",
    en: "Triage",
  },
  mapElementLine: {
    pl: "Linia",
    en: "Line",
  },
  mapElementCloud: {
    pl: "Chmura",
    en: "Cloud",
  },
  mapElementList: {
    pl: "Lista elementów",
    en: "Elements list",
  },
  jointList: {
    pl: "Lista spoin",
    en: "Joints list",
  },
  joints: {
    pl: "Spoiny",
    en: "Joints",
  },
  elements: {
    pl: "Elementy",
    en: "Elements",
  },
  size: {
    pl: "Rozmiar",
    en: "Size",
  },
  rotation: {
    pl: "Obrót",
    en: "Rotation",
  },
  length: {
    pl: "Długość",
    en: "Length",
  },
  thickness: {
    pl: "Grubość",
    en: "Thickness",
  },
  sections: {
    pl: "Lista sekcji",
    en: "Sections list",
  },
  weldingLog: {
    pl: "Dziennik spawania",
    en: "Welding log",
  },
  weldingLogSection: {
    pl: "Dziennik spawania - Sekcja",
    en: "Welding log - Section",
  },
  spools: {
    pl: "Spoole",
    en: "Spools",
  },
  existingJoint: {
    pl: "Istniejąca spoina",
    en: "Existing joint",
  },
  existingSpool: {
    pl: "Istniejący spool",
    en: "Existing spool",
  },
  welding_date: {
    pl: "Data spawania",
    en: "Welding date",
  },
  welder: {
    pl: "Spawacz",
    en: "Welder",
  },
  melt_number_1: {
    pl: "Numer wytopu 1",
    en: "Melt number 1",
  },
  melt_number_2: {
    pl: "Numer wytopu 2",
    en: "Melt number 2",
  },
  vt_examination_number: {
    pl: "Numer badania VT",
    en: "VT examination number",
  },
  vt_examination_date: {
    pl: "Data badania VT",
    en: "VT examination date",
  },
  vt_examination_result: {
    pl: "Wynik badania VT",
    en: "VT examination result",
  },
  rt_examination_number: {
    pl: "Numer badania RT",
    en: "RT examination number",
  },
  rt_examination_date: {
    pl: "Data badania RT",
    en: "RT examination date",
  },
  rt_examination_result: {
    pl: "Wynik badania RT",
    en: "RT examination result",
  },
  pt_examination_number: {
    pl: "Numer badania PT",
    en: "PT examination number",
  },
  pt_examination_date: {
    pl: "Data badania PT",
    en: "PT examination date",
  },
  pt_examination_result: {
    pl: "Wynik badania PT",
    en: "PT examination result",
  },
  ut_examination_number: {
    pl: "Numer badania UT",
    en: "UT examination number",
  },
  ut_examination_date: {
    pl: "Data badania UT",
    en: "UT examination date",
  },
  ut_examination_result: {
    pl: "Wynik badania UT",
    en: "UT examination result",
  },

  mt_examination_number: {
    pl: "Numer badania MT",
    en: "MT examination number",
  },
  mt_examination_date: {
    pl: "Data badania MT",
    en: "MT examination date",
  },
  mt_examination_result: {
    pl: "Wynik badania MT",
    en: "MT examination result",
  },
  exportWeldMap: {
    pl: "Eksport mapy spoin",
    en: "Joint map export",
  },
  exportWeldLog: {
    pl: "Eksport dziennika spawania",
    en: "Welding log export",
  },
  forSection: {
    pl: "dla sekcji",
    en: "for section",
  },
  forProject: {
    pl: "dla projektu",
    en: "for project",
  },
  projects: {
    pl: "Projekty",
    en: "Projects",
  },
  contractMembers: {
    pl: "Użytkownicy w kontrakcie",
    en: "Users in contract",
  },
  projectMembers: {
    pl: "Użytkownicy w projekcie",
    en: "Users in project",
  },
  emptyContractMembers: {
    pl: "Wybierz kontrakt aby wyświetlić jego szczegóły",
    en: "Select a contract to view its details",
  },
  emptyMemberPanel: {
    pl: "Wybierz użytkownika aby wyświetlić jego szczegóły",
    en: "Select a member to view their details",
  },
  noMembersInContract: {
    pl: "Do tego kontraktu nie jest przypisany żaden użytkownik",
    en: "No user is assigned to this contract",
  },
  noContractsInMember: {
    pl: "Ten użytkownik nie jest przypisany do żadnego kontraktu",
    en: "This user is not assigned to any contract",
  },

  deleteContract: {
    pl: "Usuń kontrakt",
    en: "Delete a contract",
  },

  addContractToMemberTitle: {
    pl: "Dodaj kontrakt do użytkownika",
    en: "Add a contract to the user",
  },

  noAvailableContract: {
    pl: "Użytkownik przypisany jest do wszystkich projektów",
    en: "The user is assigned to all projects",
  },
  membersDetails: {
    pl: "Szczegóły użytkownika",
    en: "User details",
  },

  manageAccess: {
    pl: "Zarządzaj dostępem",
    en: "Manage access",
  },
  userManagement: {
    pl: "Zarządzanie użytkownikami",
    en: "User management",
  },
  accessManagement: {
    pl: "Zarządzanie dostępem",
    en: "Access management",
  },
  editUser: {
    pl: "Edytuj użytkownika",
    en: "Edit user",
  },
  deleteUser: {
    pl: "Usuń użytkownika",
    en: "Delete user",
  },
  cancelInvitation: {
    pl: "Anuluj zaproszenie",
    en: "Cancel invitation",
  },
  dateSent: {
    pl: "Data wysłania",
    en: "Date sent",
  },
  invitationsSent: {
    pl: "Wysłane zaproszenia",
    en: "Invitations sent",
  },
  organizations: {
    pl: "Organizacje",
    en: "Organizations",
  },
  organizationName: {
    pl: "Nazwa organizacji",
    en: "Organization name",
  },
  licenses: {
    pl: "Licencje",
    en: "Licenses",
  },
  usageSpace: {
    pl: "Użyta przestrzeń dyskowa",
    en: "Disk space used",
  },
  activeSince: {
    pl: "Aktywna od",
    en: "Active since",
  },
  activeTo: {
    pl: "Aktywna do",
    en: "Active to",
  },
  nextPay: {
    pl: "Następna płatność",
    en: "Next payment due",
  },
  nextPaymentValue: {
    pl: "Kwota następnej płatności",
    en: "Next payment amount",
  },
  validUntil: {
    pl: "ważna do",
    en: "valid until",
  },
  paymentMethod: {
    pl: "Metoda płatności",
    en: "Payment method",
  },
  drawingNumber: {
    pl: "Numer rysunku",
    en: "Drawing number",
  },
  noUsersInOrg: {
    pl: "W organizacji nie żadnych użytkowników",
    en: "There are no users in the organization",
  },

  vatPerMonth: {
    pl: "VAT / miesiąc",
    en: "VAT / month",
  },
  companyName: {
    pl: "Nazwa firmy",
    en: "Company name",
  },
  companyAdressLine1: {
    pl: "Adres firmy",
    en: "Company address",
  },
  companyAdressLine2: {
    pl: "Adres firmy cd ..",
    en: "Company address cont.",
  },
  companyPostCode: {
    pl: "Kod pocztowy",
    en: "Postcode",
  },
  companyCity: {
    pl: "Miasto",
    en: "City",
  },
  companyCountry: {
    pl: "Kraj",
    en: "Country",
  },
  companyNip: {
    pl: "NIP",
    en: "VAT EU",
  },
  mainEmail: {
    pl: "Adres email organizacji",
    en: "Organization e-mail address",
  },

  editBillingAddressModalTitle: {
    pl: "Edycja danych rozliczeniowych",
    en: "Editing billing data",
  },
  editNipModalTitle: {
    pl: "Edycja numeru NIP",
    en: "Editing TAX ID number",
  },
  editOrgNameModalTitle: {
    pl: "Edycja nazwy organizacji",
    en: "Editing organization name",
  },
  editOrgEmailModalTitle: {
    pl: "Edycja adresu email",
    en: "Editing email address",
  },
  poland: {
    pl: "Polska",
    en: "Poland",
  },
  showConnectingWelds: {
    pl: "Pokaż spoiny łączące",
    en: "Show connecting welds",
  },
  confirmCancelSubscription: {
    pl: "Potwierdź anulowanie subskrypcji",
    en: "Confirm your subscription cancellation",
  },
  subcriptionCanceled: {
    pl: "Subskrypcja anulowana",
    en: "Subscription cancelled",
  },
  subcriptionReactivated: {
    pl: "Subskrypcja przywrócona",
    en: "Subscription reactivated",
  },
  confirmReactivateSubscription: {
    pl: "Potwierdź przywrócenie subskrypcji",
    en: "Confirm subscription reactivation",
  },
  doYouWantCanelSubscription: {
    pl: "Czy na pewno chcesz anulować subskrypcję? Po anulowaniu dostęp do usługi wygaśnie z końcem bieżącego okresu rozliczeniowego. Zostaną usunięte wtedy wszystkie dane oraz wszyscy użytkownicy Twojej organizacji.",
    en: "Are you sure you want to cancel your subscription? Once cancelled, your access to the service will expire at the end of your current billing period. All data and all users of your organization will then be deleted",
  },
  doYouWantReactivateSubscription: {
    pl: "Czy chcesz przywrócić swoją subskrybcje?",
    en: "Would you like to reactivate your subscription?",
  },
  enterCANCEL: {
    pl: "wpisz THE END aby potwierdzić",
    en: "type THE END to confirm",
  },
  cancelSubscription: {
    pl: "Anuluj subskrypcję",
    en: "Cancel subscription",
  },
  reactivateSubscription: {
    pl: "Przywróć subskrypcje",
    en: "Reactivate subscription",
  },
  alreadyCanceled: {
    pl: "Subskrypcja została anulowana, możesz korzystać z aplikacji do końca bieżącego okresu rozliczeniowego. Po tym okresie dostęp do aplikacji zostanie zablokowany a wszystkie dane nieodwracalnie usunięte",
    en: "The subscription has been canceled, you can use the application until the end of the current billing period. After this period, access to the application will be blocked and all data will be irreversibly deleted",
  },
  alreadyReactivated: {
    pl: "Subskrypcja została przywrócona. Następna płatność zostanie pobrana na koniec bieżącego okresu rozliczeniowego. ",
    en: "Your subscription has been reinstated. Your next payment will be taken at the end of your current billing period.",
  },

  youCanRevert: {
    pl: "Do końca bieżącego okresu rozliczeniowego możesz cofnąć tą akcję",
    en: "You can undo this action until the end of the current billing period",
  },
  registerTerms_prefix: {
    pl: "Zapoznałem/am się z",
    en: "I have read the",
  },
  registerTerms_termsOfUSe: {
    pl: "Regulaminem",
    en: "Terms of use",
  },
  registerTerms_and: {
    pl: "i",
    en: "and",
  },
  registerTerms_policy: {
    pl: "Polityką prywatności",
    en: "Privacy Policy",
  },
  registerTerms_sufix: {
    pl: "oraz akceptuję ich treść.",
    en: "and accept their content.",
  },
  registerTerms_emailSubscription: {
    pl: "Wyrażam zgodę na otrzymywanie newslettera oraz informacji handlowych, w tym o promocjach i nowościach, na podany adres e-mail. Wiem, że mogę wycofać zgodę w dowolnym momencie.",
    en: "I consent to receiving the newsletter and commercial information, including promotions and new products, to the e-mail address provided. I know that I can withdraw my consent at any time.",
  },
  alreadyInvitation: {
    pl: "Podany adres email jest już użyty.",
    en: "The email address you provided is already in use.",
  },
  dot: {
    pl: "Punkt",
    en: "Dot",
  },
  edge: {
    pl: "Prosta",
    en: "Edge",
  },
  triage: {
    pl: "Trójkąt",
    en: "Triage",
  },
  cloud: {
    pl: "Chmurka",
    en: "Cloud",
  },
  usedEmailAdress: {
    pl: "Ten adres email jest już użyty",
    en: "This email address is already in use",
  },
  selectContract: {
    pl: "Wybierz kontrakt",
    en: "Select a contract",
  },
  pleaseSelect: {
    pl: "Wybierz",
    en: "Please select",
  },
  goToHomePage: {
    pl: "Przejdź do strony głównej",
    en: "Go to home page",
  },
  fields: {
    pl: "Pola",
    en: "Fields",
  },

  mainWeldingLog: {
    pl: "Dziennik spawania ogólny",
    en: "Main welding log",
  },
  sectionWeldingLog: {
    pl: "Dziennik spawania - sekcja",
    en: "Section welding log",
  },
  jointDetails: {
    pl: "Szczególy spoiny",
    en: "Joint details",
  },
  addJointForm: {
    pl: "Formularz dodania spoiny",
    en: "Add joint form",
  },
  projectList: {
    pl: "Lista projektów",
    en: "Projects list",
  },
  addProjectForm: {
    pl: "Formularz dodania projektu",
    en: "Add project form",
  },
  sectionsList: {
    pl: "Lista sekcji",
    en: "Sections list",
  },
  addSectionForm: {
    pl: "Formularz dodania sekcji",
    en: "Add section form",
  },
  visible: {
    pl: "Widoczne",
    en: "Visible",
  },
  active: {
    pl: "Aktywne",
    en: "Active",
  },
  unactive: {
    pl: "Nieaktywne",
    en: "Inactive",
  },
  joint: {
    pl: "Spoina",
    en: "Weld",
  },
  spoolName: {
    pl: "Nazwa spoola",
    en: "Spool name",
  },
  spoolWelds: {
    pl: "Spoiny w spoolu",
    en: "Welds in spool",
  },
  noWeldsInThisSection: {
    pl: "Brak spoin w tej sekcji",
    en: "No welds in this section",
  },
  noSpoolsInThisSection: {
    pl: "Brak spooli w tej sekcji",
    en: "No spools in this section",
  },
  noWeldsInThisSpool: {
    pl: "Brak spoin w tym spoolu",
    en: "No welds in this spool",
  },
  noElementsInThisSection: {
    pl: "Brak elementów w tej sekcji",
    en: "No elements in this section",
  },
  admin: {
    pl: "admin",
    en: "admin",
  },
  editing: {
    pl: "edytujący",
    en: "editing",
  },
  readOnly: {
    pl: "tylko odczyt",
    en: "read only",
  },
  showDeletedUsers: {
    pl: "Pokaż usuniętych użytkowników",
    en: "Show deleted users",
  },
  userDeleted: {
    pl: "Użytkownik usunięty",
    en: "User deleted",
  },
  zoomInTooltip: {
    pl: "Przybliż",
    en: "Zoom in",
  },
  zoomOutTooltip: {
    pl: "Oddal",
    en: "Zoom out",
  },
  fitToScreenTooltip: {
    pl: "Dopasuj do ekranu",
    en: "Fit to screen",
  },
  originalSizeTooltip: {
    pl: "Rozmiar oryginalny",
    en: "Original size",
  },
  addJointTooltip: {
    pl: "Dodawanie spoiny",
    en: "Add weld",
  },
  editDrawingTooltip: {
    pl: "Edytuj rysunek",
    en: "Edit drawing",
  },
  pricingName_Demo: {
    pl: "Demo",
    en: "Demo",
  },
  pricingName_Solo: {
    pl: "Pojedynczy",
    en: "Solo",
  },

  pricingName_Basic: {
    pl: "Podstawowy",
    en: "Basic",
  },
  pricingName_Premium: {
    pl: "Zespołowy",
    en: "Team",
  },
  planUser: {
    pl: "użytkownik",
    en: "user",
  },
  planUsers: {
    pl: "użytkowników",
    en: "users",
  },
  rightClikcToSetNewJoint: {
    pl: "Kliknij prawym przyciskiem myszy, aby dodać nową spoinę",
    en: "Right click to add a new joint",
  },
  rightClikcToSetNewSpool: {
    pl: "Kliknij prawym przyciskiem myszy, aby dodać nowy spool",
    en: "Right click to add a new spool",
  },
  rightClikcToSetNewElement: {
    pl: "Kliknij prawym przyciskiem myszy, aby dodać nowy element wybranego typu",
    en: "Right click to add a new element of selected type",
  },
  backToList: {
    pl: "Powrót do listy",
    en: "Back to list",
  },
  invalidVatNumber: {
    pl: "Nieprawidłowy numer VAT",
    en: "Invalid VATEU number",
  },
  checkVat: {
    pl: "Sprawdź numer VAT",
    en: "Check VAT EU number",
  },
  extraTaxNumber: {
    pl: "Numer podatkowy",
    en: "Tax number",
  },
  openAccounctAsCompany: {
    pl: "Zamawiam jako firma",
    en: "I’m purchasing as a business",
  },
  waiverOfTheRightToWithdraw: {
    pl: "Wyrażam zgodę na rozpoczęcie świadczenia usługi przed upływem 14 dni od zawarcia umowy i przyjmuję do wiadomości, że tracę prawo odstąpienia od umowy.",
    en: "I agree to start the service before the end of 14 days from the conclusion of the contract and I acknowledge that I lose the right to withdraw from the contract.",
  },
  selectCountry: {
    pl: "Wybierz kraj",
    en: "Select country",
  },
  addJoint: {
    pl: "Dodaj spoinę",
    en: "Add weld",
  },
  addSpool: {
    pl: "Dodaj spool",
    en: "Add spool",
  },
  plan: {
    pl: "Plan",
    en: "Plan",
  },
};

export const countryDictionary: Record<string, { pl: string; en: string }> = {
  AD: { pl: "Andora", en: "Andorra" },
  AE: { pl: "Zjednoczone Emiraty Arabskie", en: "United Arab Emirates" },
  AF: { pl: "Afganistan", en: "Afghanistan" },
  AG: { pl: "Antigua i Barbuda", en: "Antigua and Barbuda" },
  AI: { pl: "Anguilla", en: "Anguilla" },
  AL: { pl: "Albania", en: "Albania" },
  AM: { pl: "Armenia", en: "Armenia" },
  AO: { pl: "Angola", en: "Angola" },
  AQ: { pl: "Antarktyda", en: "Antarctica" },
  AR: { pl: "Argentyna", en: "Argentina" },
  AS: { pl: "Samoa Amerykańskie", en: "American Samoa" },
  AT: { pl: "Austria", en: "Austria" },
  AU: { pl: "Australia", en: "Australia" },
  AW: { pl: "Aruba", en: "Aruba" },
  AX: { pl: "Wyspy Alandzkie", en: "Aland Islands" },
  AZ: { pl: "Azerbejdżan", en: "Azerbaijan" },
  BA: { pl: "Bośnia i Hercegowina", en: "Bosnia and Herzegovina" },
  BB: { pl: "Barbados", en: "Barbados" },
  BD: { pl: "Bangladesz", en: "Bangladesh" },
  BE: { pl: "Belgia", en: "Belgium" },
  BF: { pl: "Burkina Faso", en: "Burkina Faso" },
  BG: { pl: "Bułgaria", en: "Bulgaria" },
  BH: { pl: "Bahrajn", en: "Bahrain" },
  BI: { pl: "Burundi", en: "Burundi" },
  BJ: { pl: "Benin", en: "Benin" },
  BL: { pl: "Saint-Barthélemy", en: "Saint Barthelemy" },
  BM: { pl: "Bermudy", en: "Bermuda" },
  BN: { pl: "Brunei", en: "Brunei" },
  BO: { pl: "Boliwia", en: "Bolivia" },
  BQ: { pl: "Niderlandy Karaibskie", en: "Bonaire, Sint Eustatius and Saba" },
  BR: { pl: "Brazylia", en: "Brazil" },
  BS: { pl: "Bahamy", en: "Bahamas" },
  BT: { pl: "Bhutan", en: "Bhutan" },
  BV: { pl: "Wyspa Bouveta", en: "Bouvet Island" },
  BW: { pl: "Botswana", en: "Botswana" },
  BY: { pl: "Białoruś", en: "Belarus" },
  BZ: { pl: "Belize", en: "Belize" },
  CA: { pl: "Kanada", en: "Canada" },
  CC: { pl: "Wyspy Kokosowe", en: "Cocos (Keeling) Islands" },
  CD: {
    pl: "Demokratyczna Republika Konga",
    en: "Congo, Democratic Republic of the",
  },
  CF: { pl: "Republika Środkowoafrykańska", en: "Central African Republic" },
  CG: { pl: "Kongo", en: "Congo" },
  CH: { pl: "Szwajcaria", en: "Switzerland" },
  CI: { pl: "Côte d’Ivoire", en: "Cote d'Ivoire" },
  CK: { pl: "Wyspy Cooka", en: "Cook Islands" },
  CL: { pl: "Chile", en: "Chile" },
  CM: { pl: "Kamerun", en: "Cameroon" },
  CN: { pl: "Chiny", en: "China" },
  CO: { pl: "Kolumbia", en: "Colombia" },
  CR: { pl: "Kostaryka", en: "Costa Rica" },
  CU: { pl: "Kuba", en: "Cuba" },
  CV: { pl: "Republika Zielonego Przylądka", en: "Cape Verde" },
  CW: { pl: "Curaçao", en: "Curacao" },
  CX: { pl: "Wyspa Bożego Narodzenia", en: "Christmas Island" },
  CY: { pl: "Cypr", en: "Cyprus" },
  CZ: { pl: "Czechy", en: "Czechia" },
  DE: { pl: "Niemcy", en: "Germany" },
  DJ: { pl: "Dżibuti", en: "Djibouti" },
  DK: { pl: "Dania", en: "Denmark" },
  DM: { pl: "Dominika", en: "Dominica" },
  DO: { pl: "Dominikana", en: "Dominican Republic" },
  DZ: { pl: "Algieria", en: "Algeria" },
  EC: { pl: "Ekwador", en: "Ecuador" },
  EE: { pl: "Estonia", en: "Estonia" },
  EG: { pl: "Egipt", en: "Egypt" },
  EH: { pl: "Sahara Zachodnia", en: "Western Sahara" },
  ER: { pl: "Erytrea", en: "Eritrea" },
  ES: { pl: "Hiszpania", en: "Spain" },
  ET: { pl: "Etiopia", en: "Ethiopia" },
  FI: { pl: "Finlandia", en: "Finland" },
  FJ: { pl: "Fidżi", en: "Fiji" },
  FK: { pl: "Falklandy", en: "Falkland Islands" },
  FM: { pl: "Mikronezja", en: "Micronesia" },
  FO: { pl: "Wyspy Owcze", en: "Faroe Islands" },
  FR: { pl: "Francja", en: "France" },
  GA: { pl: "Gabon", en: "Gabon" },
  GB: { pl: "Wielka Brytania", en: "United Kingdom" },
  GD: { pl: "Grenada", en: "Grenada" },
  GE: { pl: "Gruzja", en: "Georgia" },
  GF: { pl: "Gujana Francuska", en: "French Guiana" },
  GG: { pl: "Guernsey", en: "Guernsey" },
  GH: { pl: "Ghana", en: "Ghana" },
  GI: { pl: "Gibraltar", en: "Gibraltar" },
  GL: { pl: "Grenlandia", en: "Greenland" },
  GM: { pl: "Gambia", en: "Gambia" },
  GN: { pl: "Gwinea", en: "Guinea" },
  GP: { pl: "Gwadelupa", en: "Guadeloupe" },
  GQ: { pl: "Gwinea Równikowa", en: "Equatorial Guinea" },
  EL: { pl: "Grecja", en: "Greece" },
  GS: {
    pl: "Georgia Południowa i Sandwich Południowy",
    en: "South Georgia and the South Sandwich Islands",
  },
  GT: { pl: "Gwatemala", en: "Guatemala" },
  GU: { pl: "Guam", en: "Guam" },
  GW: { pl: "Gwinea Bissau", en: "Guinea-Bissau" },
  GY: { pl: "Gujana", en: "Guyana" },
  HK: { pl: "SRA Hongkong (Chiny)", en: "Hong Kong" },
  HM: {
    pl: "Wyspy Heard i McDonalda",
    en: "Heard Island and McDonald Islands",
  },
  HN: { pl: "Honduras", en: "Honduras" },
  HR: { pl: "Chorwacja", en: "Croatia" },
  HT: { pl: "Haiti", en: "Haiti" },
  HU: { pl: "Węgry", en: "Hungary" },
  ID: { pl: "Indonezja", en: "Indonesia" },
  IE: { pl: "Irlandia", en: "Ireland" },
  IL: { pl: "Izrael", en: "Israel" },
  IM: { pl: "Wyspa Man", en: "Isle of Man" },
  IN: { pl: "Indie", en: "India" },
  IO: {
    pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
    en: "British Indian Ocean Territory",
  },
  IQ: { pl: "Irak", en: "Iraq" },
  IR: { pl: "Iran", en: "Iran" },
  IS: { pl: "Islandia", en: "Iceland" },
  IT: { pl: "Włochy", en: "Italy" },
  JE: { pl: "Jersey", en: "Jersey" },
  JM: { pl: "Jamajka", en: "Jamaica" },
  JO: { pl: "Jordania", en: "Jordan" },
  JP: { pl: "Japonia", en: "Japan" },
  KE: { pl: "Kenia", en: "Kenya" },
  KG: { pl: "Kirgistan", en: "Kyrgyzstan" },
  KH: { pl: "Kambodża", en: "Cambodia" },
  KI: { pl: "Kiribati", en: "Kiribati" },
  KM: { pl: "Komory", en: "Comoros" },
  KN: { pl: "Saint Kitts i Nevis", en: "Saint Kitts and Nevis" },
  KP: { pl: "Korea Północna", en: "North Korea" },
  KR: { pl: "Korea Południowa", en: "South Korea" },
  KW: { pl: "Kuwejt", en: "Kuwait" },
  KY: { pl: "Kajmany", en: "Cayman Islands" },
  KZ: { pl: "Kazachstan", en: "Kazakhstan" },
  LA: { pl: "Laos", en: "Laos" },
  LB: { pl: "Liban", en: "Lebanon" },
  LC: { pl: "Saint Lucia", en: "Saint Lucia" },
  LI: { pl: "Liechtenstein", en: "Liechtenstein" },
  LK: { pl: "Sri Lanka", en: "Sri Lanka" },
  LR: { pl: "Liberia", en: "Liberia" },
  LS: { pl: "Lesotho", en: "Lesotho" },
  LT: { pl: "Litwa", en: "Lithuania" },
  LU: { pl: "Luksemburg", en: "Luxembourg" },
  LV: { pl: "Łotwa", en: "Latvia" },
  LY: { pl: "Libia", en: "Libya" },
  MA: { pl: "Maroko", en: "Morocco" },
  MC: { pl: "Monako", en: "Monaco" },
  MD: { pl: "Mołdawia", en: "Moldova" },
  ME: { pl: "Czarnogóra", en: "Montenegro" },
  MF: { pl: "Saint-Martin", en: "Saint Martin" },
  MG: { pl: "Madagaskar", en: "Madagascar" },
  MH: { pl: "Wyspy Marshalla", en: "Marshall Islands" },
  MK: { pl: "Macedonia Północna", en: "North Macedonia" },
  ML: { pl: "Mali", en: "Mali" },
  MM: { pl: "Mjanma (Birma)", en: "Myanmar" },
  MN: { pl: "Mongolia", en: "Mongolia" },
  MO: { pl: "SRA Makau (Chiny)", en: "Macao" },
  MP: { pl: "Mariany Północne", en: "Northern Mariana Islands" },
  MQ: { pl: "Martynika", en: "Martinique" },
  MR: { pl: "Mauretania", en: "Mauritania" },
  MS: { pl: "Montserrat", en: "Montserrat" },
  MT: { pl: "Malta", en: "Malta" },
  MU: { pl: "Mauritius", en: "Mauritius" },
  MV: { pl: "Malediwy", en: "Maldives" },
  MW: { pl: "Malawi", en: "Malawi" },
  MX: { pl: "Meksyk", en: "Mexico" },
  MY: { pl: "Malezja", en: "Malaysia" },
  MZ: { pl: "Mozambik", en: "Mozambique" },
  NA: { pl: "Namibia", en: "Namibia" },
  NC: { pl: "Nowa Kaledonia", en: "New Caledonia" },
  NE: { pl: "Niger", en: "Niger" },
  NF: { pl: "Norfolk", en: "Norfolk Island" },
  NG: { pl: "Nigeria", en: "Nigeria" },
  NI: { pl: "Nikaragua", en: "Nicaragua" },
  NL: { pl: "Holandia", en: "Netherlands" },
  NO: { pl: "Norwegia", en: "Norway" },
  NP: { pl: "Nepal", en: "Nepal" },
  NR: { pl: "Nauru", en: "Nauru" },
  NU: { pl: "Niue", en: "Niue" },
  NZ: { pl: "Nowa Zelandia", en: "New Zealand" },
  OM: { pl: "Oman", en: "Oman" },
  PA: { pl: "Panama", en: "Panama" },
  PE: { pl: "Peru", en: "Peru" },
  PF: { pl: "Polinezja Francuska", en: "French Polynesia" },
  PG: { pl: "Papua-Nowa Gwinea", en: "Papua New Guinea" },
  PH: { pl: "Filipiny", en: "Philippines" },
  PK: { pl: "Pakistan", en: "Pakistan" },
  PL: { pl: "Polska", en: "Poland" },
  PM: { pl: "Saint-Pierre i Miquelon", en: "Saint Pierre and Miquelon" },
  PN: { pl: "Pitcairn", en: "Pitcairn" },
  PR: { pl: "Portoryko", en: "Puerto Rico" },
  PS: { pl: "Terytoria Palestyńskie", en: "Palestine" },
  PT: { pl: "Portugalia", en: "Portugal" },
  PW: { pl: "Palau", en: "Palau" },
  PY: { pl: "Paragwaj", en: "Paraguay" },
  QA: { pl: "Katar", en: "Qatar" },
  RE: { pl: "Reunion", en: "Reunion" },
  RO: { pl: "Rumunia", en: "Romania" },
  RS: { pl: "Serbia", en: "Serbia" },
  RU: { pl: "Rosja", en: "Russia" },
  RW: { pl: "Rwanda", en: "Rwanda" },
  SA: { pl: "Arabia Saudyjska", en: "Saudi Arabia" },
  SB: { pl: "Wyspy Salomona", en: "Solomon Islands" },
  SC: { pl: "Seszele", en: "Seychelles" },
  SD: { pl: "Sudan", en: "Sudan" },
  SE: { pl: "Szwecja", en: "Sweden" },
  SG: { pl: "Singapur", en: "Singapore" },
  SH: { pl: "Wyspa Świętej Heleny", en: "Saint Helena" },
  SI: { pl: "Słowenia", en: "Slovenia" },
  SJ: { pl: "Svalbard i Jan Mayen", en: "Svalbard and Jan Mayen" },
  SK: { pl: "Słowacja", en: "Slovakia" },
  SL: { pl: "Sierra Leone", en: "Sierra Leone" },
  SM: { pl: "San Marino", en: "San Marino" },
  SN: { pl: "Senegal", en: "Senegal" },
  SO: { pl: "Somalia", en: "Somalia" },
  SR: { pl: "Surinam", en: "Suriname" },
  SS: { pl: "Sudan Południowy", en: "South Sudan" },
  ST: { pl: "Wyspy Świętego Tomasza i Książęca", en: "Sao Tome and Principe" },
  SV: { pl: "Salwador", en: "El Salvador" },
  SX: { pl: "Sint Maarten", en: "Sint Maarten" },
  SY: { pl: "Syria", en: "Syria" },
  SZ: { pl: "Eswatini", en: "Eswatini" },
  TC: { pl: "Turks i Caicos", en: "Turks and Caicos Islands" },
  TD: { pl: "Czad", en: "Chad" },
  TF: {
    pl: "Francuskie Terytoria Południowe i Antarktyczne",
    en: "French Southern Territories",
  },
  TG: { pl: "Togo", en: "Togo" },
  TH: { pl: "Tajlandia", en: "Thailand" },
  TJ: { pl: "Tadżykistan", en: "Tajikistan" },
  TK: { pl: "Tokelau", en: "Tokelau" },
  TL: { pl: "Timor Wschodni", en: "Timor-Leste" },
  TM: { pl: "Turkmenistan", en: "Turkmenistan" },
  TN: { pl: "Tunezja", en: "Tunisia" },
  TO: { pl: "Tonga", en: "Tonga" },
  TR: { pl: "Turcja", en: "Turkey" },
  TT: { pl: "Trynidad i Tobago", en: "Trinidad and Tobago" },
  TV: { pl: "Tuvalu", en: "Tuvalu" },
  TW: { pl: "Tajwan", en: "Taiwan" },
  TZ: { pl: "Tanzania", en: "Tanzania" },
  UA: { pl: "Ukraina", en: "Ukraine" },
  UG: { pl: "Uganda", en: "Uganda" },
  UM: {
    pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
    en: "United States Minor Outlying Islands",
  },
  US: { pl: "Stany Zjednoczone", en: "United States" },
  UY: { pl: "Urugwaj", en: "Uruguay" },
  UZ: { pl: "Uzbekistan", en: "Uzbekistan" },
  VA: { pl: "Watykan", en: "Vatican City" },
  VC: {
    pl: "Saint Vincent i Grenadyny",
    en: "Saint Vincent and the Grenadines",
  },
  VE: { pl: "Wenezuela", en: "Venezuela" },
  VG: { pl: "Brytyjskie Wyspy Dziewicze", en: "British Virgin Islands" },
  VI: {
    pl: "Wyspy Dziewicze Stanów Zjednoczonych",
    en: "United States Virgin Islands",
  },
  VN: { pl: "Wietnam", en: "Vietnam" },
  VU: { pl: "Vanuatu", en: "Vanuatu" },
  WF: { pl: "Wallis i Futuna", en: "Wallis and Futuna" },
  WS: { pl: "Samoa", en: "Samoa" },
  YE: { pl: "Jemen", en: "Yemen" },
  YT: { pl: "Majotta", en: "Mayotte" },
  ZA: { pl: "Republika Południowej Afryki", en: "South Africa" },
  ZM: { pl: "Zambia", en: "Zambia" },
  ZW: { pl: "Zimbabwe", en: "Zimbabwe" },
};
